export default class Message {
  static createMessage(msg_text, msg_type = "error") {
    return { text: msg_text, type: msg_type };
  }
}
